import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Box, Grid } from "@material-ui/core";
import {Trans, useTranslation} from "react-i18next";
import OrdersStoreContext from "./store/context";
import { useStores } from "../../../../hooks";
import { Centered, Divider, Space, Typography } from "../../../../common/components/libs";
import ChooseMenu from "./components/ChooseMenu";
import { FadeInOutVertical } from "../../../../common/components/Animated";
import FilterForTable from "./components/table/FilterForTable";
import FilterForCard from "./components/card/FilterForCard";
import NoOrders from "./components/NoOrders";
import OrdersTable from "./components/table/OrdersTable";
import OrderCard from "./components/card/OrderCard";


const OrdersList = () => {
    const { generalStore } = useStores();
    const ordersStore = useContext(OrdersStoreContext);
    const { ordersList } = ordersStore;
    const {i18n, t, ready} = useTranslation(["orders"], { useSuspense: false });
    const locale = i18n.language;

    const filter = ordersStore.filter;

    useEffect(() => {
        ordersStore.init();
        generalStore.setPageTitle(t("orders:title"));
    }, [ready]);

    useEffect(() => {
        ordersStore.getOrders({
            ...filter
        });
    }, [ordersStore.filter]);


    if (!ordersList) return null;

    const orders = ordersList.slice().reverse();


    return <>
        <Helmet title={t("orders:title")}/>
        <Grid justify="space-between" alignItems='center' container spacing={8}>
            <Grid item>
                <Typography variant="h3" ml={2}>
                    {t("orders:infoShortTitle")}
                </Typography>
            </Grid>
            <Grid item>
                <ChooseMenu/>
            </Grid>
        </Grid>
        <Divider my={6}/>
        <Grid container spacing={6}>
            <Grid item xs={12} style={{ marginBottom: "150px" }}>
                <FadeInOutVertical show={true}>
                    <div>
                        <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                            <FilterForTable/>
                        </Box>
                        <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                            <FilterForCard/>
                        </Box>
                        {orders.length === 0 &&
                        <Centered>
                          <NoOrders/>
                        </Centered>
                        }
                        {orders.length > 0 &&
                        <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                          <OrdersTable orders={orders}/>
                        </Box>
                        }
                        {orders.length > 0 &&
                        <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                            {orders.map((order) => {
                                return (
                                    <>
                                        <OrderCard order={order}/>
                                        <Space size={10}/>
                                    </>
                                );
                            })}
                        </Box>
                        }
                    </div>
                </FadeInOutVertical>
            </Grid>
        </Grid>


    </>;
};


export default observer(OrdersList);
